// About.jsx
import React from 'react';
import devLap from '../assets/dev-lap.png';
import devMobile from '../assets/dev-mobile.png';
import devOps from '../assets/dev-ops.png';
import devConsulting from '../assets/dev-consulting.png';
import './style.css';

const About = () => {
  return (
    <div className="about-container">
      <header className="about-header">
        <h1>About Us</h1>
        <p className="about-tagline">Your trusted partner in IT consulting and development</p>
      </header>

      <section className="about-mission subSection">
        <h2>Our Mission</h2>
        <p>
          Our mission is to deliver innovative, tailor-made IT solutions that help our clients achieve their strategic goals.
          We are committed to providing top-quality services by combining technical expertise, creativity, and a deep understanding
          of business needs.
        </p>
      </section>

      <section className="about-expertise subSection">
        <h2>Our Expertise</h2>
        <div className="expertise-grid">
          <div className="expertise-card">
            <img src={devLap} alt="Web Development" />
            <h3>Web Development</h3>
            <p>Dynamic websites, React applications, e-commerce solutions, and enterprise intranets.</p>
          </div>
          
          <div className="expertise-card">
            <img src={devMobile} alt="Mobile Development" />
            <h3>Mobile Development</h3>
            <p>Native and cross-platform apps for iOS and Android using modern technologies.</p>
          </div>
          
          <div className="expertise-card">
            <img src={devOps} alt="DevOps & Cloud" />
            <h3>DevOps & Cloud</h3>
            <p>CI/CD setup, cloud migrations, and infrastructure optimization.</p>
          </div>
          
          <div className="expertise-card">
            <img src={devConsulting} alt="IT Consulting" />
            <h3>IT Consulting</h3>
            <p>Strategic advisory, technical audits, IT governance, and digital transformation.</p>
          </div>
        </div>
      </section>

      <section className="about-team subSection">
        <h2>Our Team</h2>
        <p>
          Our strength lies in our team of passionate consultants and developers. Experts in their fields,
          our people combine deep technical skills with strong business experience to deliver exceptional service.
        </p>
        <div className="team-stats">
          <div className="stat">
            <span className="stat-number">+10</span>
            <span className="stat-label">Years of experience</span>
          </div>
          <div className="stat">
            <span className="stat-number">+50</span>
            <span className="stat-label">Projects completed</span>
          </div>
          <div className="stat">
            <span className="stat-number">+20</span>
            <span className="stat-label">Satisfied clients</span>
          </div>
        </div>
      </section>

      <section className="about-approach subSection">
        <h2>Our Approach</h2>
        <div className="approach-steps">
          <div className="approach-step">
            <div className="step-number">1</div>
            <h3>Analysis</h3>
            <p>We take the time to understand your specific needs and business objectives.</p>
          </div>
          
          <div className="approach-step">
            <div className="step-number">2</div>
            <h3>Strategy</h3>
            <p>We design a tailored solution that fits your requirements and constraints.</p>
          </div>
          
          <div className="approach-step">
            <div className="step-number">3</div>
            <h3>Development</h3>
            <p>We build your solution using best-in-class technologies and practices.</p>
          </div>
          
          <div className="approach-step">
            <div className="step-number">4</div>
            <h3>Delivery</h3>
            <p>We deploy your solution and provide ongoing monitoring and dedicated support.</p>
          </div>
        </div>
      </section>

      <section className="about-values subSection">
        <h2>Our Values</h2>
        <div className="values-container">
          <div className="value-item">
            <h3>Excellence</h3>
            <p>We strive for excellence in every aspect of our work.</p>
          </div>
          
          <div className="value-item">
            <h3>Innovation</h3>
            <p>We stay at the forefront of technology to provide the best solutions.</p>
          </div>
          
          <div className="value-item">
            <h3>Integrity</h3>
            <p>We operate with transparency and honesty in all our relationships.</p>
          </div>
          
          <div className="value-item">
            <h3>Collaboration</h3>
            <p>We believe in close partnerships with our clients for shared success.</p>
          </div>
        </div>
      </section>

      <section className="about-contact">
        <h2>Let's Work Together</h2>
        <p>
          Ready to turn your IT vision into reality? Contact us today to discuss your projects and discover how we can help you reach your goals.
        </p>
        <button className="contact-button">Contact Us</button>
      </section>
    </div>
  );
};

export default About;